import * as Sentry from "@sentry/gatsby";

import "@fontsource-variable/figtree";
import "react-international-phone/style.css";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-creative";
import "swiper/css/autoplay";
import "swiper/css/zoom";
import "swiper/css/effect-coverflow";

import "./src/styles/global.css";

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
});
Sentry.init({
  dsn: "https://4e7f94a7ce8b4eb1f11da06e0c475218@o4504921838649344.ingest.us.sentry.io/4510274264104960",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        "https://api.leadcreativeturkey.com/api/crm/form/std",
      ],
      networkRequestHeaders: ["X-Custom-Header"],
      networkResponseHeaders: ["X-Custom-Header"],
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
